<script lang="typescript">
    import PriceDisplayXL from "./PriceDisplayXL.svelte";

    export let price: number;
    export let name: string;
    export let image: string;
    export let baseHeightClass: string;
</script>

<div class="container {baseHeightClass}">
    <img
        type="image/svg+xml"
        src={image}
        class="lens-image xl:mr-4 w-24 mt-4 xl:mt-0"
        alt="spectacle lens option"
    />
    <div
        class="
	w-auto
	flex
	flex-col
	items-center
	justify-between
  xl:align-middle
	xl:items-start
	xl:justify-start"
    >
        <span class="block text-xl font-medium mb-2 text-center xl:text-left">
            {@html name}
        </span>
        <PriceDisplayXL classes="mt-auto mb-0" bind:price />
    </div>
</div>

<style>
    .container {
        @apply flex items-center xl:items-center xl:ml-2;
        @apply flex-col xl:flex-row w-auto xl:mb-4 xl:mt-6 xl:mx-4 flex-shrink-0;
        max-width: 21rem;
    }

    .container .lens-image {
        @apply xl:w-32;
    }

    .container.upgrade .lens-image {
        @apply xl:w-1/2;
    }

    @media (min-width: 1280px) {
        .container {
            width: 21rem;
        }
    }
</style>
